import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i0 from '@angular/core';
import { forwardRef, Component, Input, EventEmitter, Directive, Output, HostListener, NgModule } from '@angular/core';
import '@anthem/uxd/util';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

//istanbul ignore next
class ToggleSwitchComponent {
    _onChangeCallback(value) {
        // noop
    }
    _onTouchedCallback() {
        // noop
    }
    constructor(_renderer) {
        this._renderer = _renderer;
        this.options = [];
        this.labelText = '';
        this.id = '';
        this.legendSrOnly = false;
        this.analyticsId = '';
        this.toggle = {
            id: '',
            legendSrOnly: false,
            labelText: '',
            options: null
        };
    }
    ngAfterViewInit() {
        //noop
    }
    ngOnInit() {
        if (this.id) {
            this.toggle.id = this.id;
        }
        if (typeof this.options !== 'undefined' && this.options.length) {
            this.toggle.options = this.options;
        }
        if (this.labelText) {
            this.toggle.labelText = this.labelText;
        }
        if (this.legendSrOnly) {
            this.toggle.legendSrOnly = this.legendSrOnly;
        }
    }
    ngOnChanges(changes) {
        //noop
    }
    onItemClick(o) {
        this.setSelected(o.value);
    }
    onItemFocus(o) {
        this.setFocus(true, o.value);
    }
    onItemBlur(o) {
        this.setFocus(false, o.value);
        this._onTouchedCallback();
    }
    writeValue(value) {
        if (value) {
            this.setSelected(value);
        }
    }
    registerOnChange(fn) {
        //todo
        this._onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        //todo
        this._onTouchedCallback = fn;
    }
    setSelected(value) {
        this.toggle.options.forEach((o) => {
            if (o.value.toString() === value.toString()) {
                o.isSelected = true;
            }
            else {
                o.isSelected = false;
            }
        });
        this._onChangeCallback(value);
    }
    setFocus(set, value) {
        this.toggle.options.forEach((o) => {
            if (o.value.toString() === value.toString()) {
                o.isFocused = set;
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ToggleSwitchComponent, deps: [{ token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ToggleSwitchComponent, selector: "[data-tcp-toggle-switch-cmp]", inputs: { options: "options", labelText: "labelText", id: "id", legendSrOnly: "legendSrOnly", analyticsId: "analyticsId", toggle: "toggle" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => ToggleSwitchComponent),
                multi: true
            }
        ], usesOnChanges: true, ngImport: i0, template: `
            <fieldset class="pfToggleSwitch">
                <legend [class.sr-only]="toggle.legendSrOnly"  [id]="'lblOptLgnd'+toggle.id" class="" [innerHTML]="toggle.labelText"></legend>
                <ng-container *ngFor="let o of toggle.options; let pIdx = index;">
                  <div class="optionWrapper">
                    <input (focus)="onItemFocus(o)" (blur)="onItemBlur(o)" (click)="onItemClick(o)" class="ptOption" type="radio" [name]="'rbtnOpt'+toggle.id" [id]="'rbtnOpt'+toggle.id+pIdx" [value]="o.value" />
                    <label [class.focus]="o.isFocused" [id]="'lblOpt'+toggle.id+pIdx" [ngClass]="{'active': (o.isSelected)}"  class="ptLabel" [attr.for]="'rbtnOpt'+toggle.id+pIdx" [attr.data-analytics]="o.analyticsId">
                      <span [innerHTML]="o.label" [attr.data-analytics]="o.analyticsId"></span>
                    </label>
                  </div>
                </ng-container>
             </fieldset>`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ToggleSwitchComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[data-tcp-toggle-switch-cmp]',
                    template: `
            <fieldset class="pfToggleSwitch">
                <legend [class.sr-only]="toggle.legendSrOnly"  [id]="'lblOptLgnd'+toggle.id" class="" [innerHTML]="toggle.labelText"></legend>
                <ng-container *ngFor="let o of toggle.options; let pIdx = index;">
                  <div class="optionWrapper">
                    <input (focus)="onItemFocus(o)" (blur)="onItemBlur(o)" (click)="onItemClick(o)" class="ptOption" type="radio" [name]="'rbtnOpt'+toggle.id" [id]="'rbtnOpt'+toggle.id+pIdx" [value]="o.value" />
                    <label [class.focus]="o.isFocused" [id]="'lblOpt'+toggle.id+pIdx" [ngClass]="{'active': (o.isSelected)}"  class="ptLabel" [attr.for]="'rbtnOpt'+toggle.id+pIdx" [attr.data-analytics]="o.analyticsId">
                      <span [innerHTML]="o.label" [attr.data-analytics]="o.analyticsId"></span>
                    </label>
                  </div>
                </ng-container>
             </fieldset>`,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => ToggleSwitchComponent),
                            multi: true
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }]; }, propDecorators: { options: [{
                type: Input
            }], labelText: [{
                type: Input
            }], id: [{
                type: Input
            }], legendSrOnly: [{
                type: Input
            }], analyticsId: [{
                type: Input
            }], toggle: [{
                type: Input
            }] } });

//istanbul ignore next
class ToggleSwitchDirective {
    constructor(_element, _renderer) {
        this._element = _element;
        this._renderer = _renderer;
        this.ngModelChange = new EventEmitter(false);
        this._isChecked = false;
    }
    ngOnInit() {
        //TODO
    }
    ngAfterViewInit() {
        if (!this._element.nativeElement.id) {
            console.error('ToggleSwitchDirective id missing !!!');
        }
        else if (!this._element.nativeElement.name) {
            console.error('ToggleSwitchDirective name missing !!!');
        }
        if (this._element.nativeElement.nextElementSibling.tagName.toLowerCase() !== 'label') {
            console.error('ToggleSwitchDirective label missing !!!');
        }
        this._renderer.addClass(this._element.nativeElement, 'ptOption');
        this._renderer.addClass(this._element.nativeElement.nextElementSibling, 'ptLabel');
        if (this._modelValue) {
            this.ngOnChanges({ _modelValue: { currentValue: this._modelValue } });
        }
    }
    ngOnChanges(changes) {
        if (typeof changes['_modelValue'] !== 'undefined' && changes['_modelValue'].currentValue && changes['_modelValue'].currentValue.toString() === this._element.nativeElement.defaultValue) {
            this._isChecked = true;
            if (this._element.nativeElement.nextElementSibling) {
                this._renderer.addClass(this._element.nativeElement.nextElementSibling, 'active');
            }
        }
        else {
            this._isChecked = false;
            if (this._element.nativeElement.nextElementSibling) {
                this._renderer.removeClass(this._element.nativeElement.nextElementSibling, 'active');
            }
        }
    }
    onFocus() {
        this._renderer.addClass(this._element.nativeElement.nextElementSibling, 'focus');
    }
    onBlur() {
        this._renderer.removeClass(this._element.nativeElement.nextElementSibling, 'focus');
    }
    onClick() {
        this._renderer.addClass(this._element.nativeElement.nextElementSibling, 'active');
        this._renderer.addClass(this._element.nativeElement.nextElementSibling, 'focus');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ToggleSwitchDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: ToggleSwitchDirective, selector: "[data-uxd-toggle-switch-dir]", inputs: { _modelValue: ["ngModel", "_modelValue"] }, outputs: { ngModelChange: "ngModelChange" }, host: { listeners: { "focus": "onFocus()", "blur": "onBlur()", "click": "onClick()" } }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ToggleSwitchDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[data-uxd-toggle-switch-dir]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { _modelValue: [{
                type: Input,
                args: ['ngModel']
            }], ngModelChange: [{
                type: Output
            }], onFocus: [{
                type: HostListener,
                args: ['focus']
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

class ToggleSwitchModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ToggleSwitchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ToggleSwitchModule, declarations: [ToggleSwitchComponent, ToggleSwitchDirective], imports: [CommonModule], exports: [ToggleSwitchComponent, ToggleSwitchDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ToggleSwitchModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ToggleSwitchModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ToggleSwitchComponent, ToggleSwitchDirective],
                    exports: [ToggleSwitchComponent, ToggleSwitchDirective]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ToggleSwitchComponent, ToggleSwitchDirective, ToggleSwitchModule };
